import { v4 as uuidv4 } from 'uuid'

export const SEARCH_DEBOUNCE = 1000

export const uuid = uuidv4()

export const SEARCH_FIELD_NAME = 'search'
